import { useState, useEffect } from 'react';
import Game from '../../../../../class/Game/Game';
import Games from '../../../../../class/Game_copy/Game';

export const useSearch = (category, limit = 10, AuthService) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [gameCount, setGameCount] = useState(0);
  const [noResult, setNoResult] = useState(false);
  const [page, setPage] = useState(1);

  const user_id = AuthService.getCustom('user_id');

  const handleSearch = async (query, pageNumber = 1, append = false) => {
    if (!query) {
      setSearchResults([]);
      setGameCount(0);
      setPage(1);
      return;
    }

    setLoading(true);
    try {
      const results = await Games.searchGameFrame(query,category,10,1, user_id);
      if (results && results.params) {
        const newResults = append
          ? [...searchResults, ...results.params.games.filter(
              (game) => !searchResults.some((existingGame) => existingGame.id === game.id)
            )]
          : results.params.games;

        setSearchResults(newResults);
        setGameCount(newResults.length);
        setNoResult(false);
      } else {
        if (!append) {
          setNoResult(true);
          setGameCount(0);
        }
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
      setNoResult(true);
      setGameCount(0);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = () => setPage((prevPage) => prevPage + 1);

  useEffect(() => {
    if (page > 1) {
      handleSearch(searchQuery, page, true);
    }
  }, [page]);

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    loading,
    gameCount,
    noResult,
    handleSearch,
    loadMore,
  };
};
